<template>
<div class="mapStyle">
  <OperatHeader>
    <div slot="left-action">
      <SearchInput></SearchInput>
    </div>
  </OperatHeader>
  <RightDrawer ref="rightDrawer" class="rightDrawer" :hiddenDrawer="permissionLevel <= PermissionLevel.LOOKER">
    <div slot="header">
      <span class="title">基础设置</span>
      <el-button type="primary" class="save-btn" @click="save" v-if="!isDisabledSave">保存</el-button>
    </div>
    <div slot="body">
      <BaseSetMap ref="baseSetMap" @changeModelHeight="changeModelHeight" @changeDisabled="changeDisabled"></BaseSetMap>
    </div>
  </RightDrawer>
</div>
</template>

<script>
import RightDrawer from '@/components/Drawer/RightDrawer'
import BaseSetMap from './components/BaseSetMap'
import OperatHeader from '@/components/OperatHeader/OperatHeader'
import SearchInput from '../components/POISearch/SearchInput'
import { getMapStyle } from '@/api/mapStyle'
import { mapGetters } from 'vuex'
import { PermissionLevel } from '@/configs/constants'
export default {
  name: 'index',
  props: {},
  components: {
    RightDrawer,
    BaseSetMap,
    OperatHeader,
    SearchInput
  },
  data () {
    return {
      mapStyleDetails: null,
      isDisabledSave: true,
      modelHeight: 1,
      PermissionLevel
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  computed: {
    ...mapGetters(['permissionLevel'])
  },
  mounted () {
    this.getMapStyle()
    this.$nextTick(() => {
      this.$store.dispatch('showLeft', false)
      this.$store.dispatch('showRight', true)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isDisabledSave) {
      this.$confirm('离开前是否保存当前地图样式设置?', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '还原',
        closeOnClickModal: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.save()
        setTimeout(() => {
          next()
        }, 1000)
      }).catch(() => {
        next()
        // this.changeModelHeight(this.modelHeight)
        this.$refs.baseSetMap.restore()
      })
    } else {
      next()
    }
  },
  methods: {
    save () {
      if (this.mapStyleDetails && this.mapStyleDetails.id) {
        this.$refs.baseSetMap.edit()
      } else {
        this.$refs.baseSetMap.save()
      }
    },
    changeDisabled (v) {
      this.isDisabledSave = v
    },
    getMapStyle () {
      this.mapStyleDetails = null
      getMapStyle({ mapId: this.$route.query.mapId }).then(res => {
        if (res.code === 200 && res.data) {
          this.mapStyleDetails = res.data
          this.modelHeight = res.data.modelHeight
          this.$refs.baseSetMap.setStyle(res.data)
        }
      })
    },
    changeModelHeight (height) {
      const cesiumViewer = this.$parent.$parent.$parent.$refs.cesiumViewer
      cesiumViewer.changeAll3dTilesetHeight(height)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.mapStyle{
  overflow: hidden;
  .rightDrawer{
    z-index: 1000;
    // top: 0;
    // top: 48px;
    position: absolute;
    .header{
      >div{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 12px;
        .save-btn{
          width: 41px;
          height: 24px;
          background: #00A4F0;
          border-radius: 6px;
          font-size: 12px;
          padding: 0 !important;
        }
      }
    }
  }
}
</style>
